/** Host reset, design tokens, box-sizing reset, root wrapper, and shared keyframes. */
export const COMMON_CSS = `
    :host {
      all: initial !important;
      --pw-icon-bg: rgba(255, 255, 255, 0.8);
      --pw-button-bg: rgba(255, 255, 255, 0.8);
      --pw-panel-bg: #FFFFFF;
      --pw-shadow-rest: 0 0.96px 7.68px rgba(0, 0, 0, 0.16);
      --pw-shadow-fab-rest: 0 1.2px 9.6px rgba(0, 0, 0, 0.2);
      --pw-shadow-hover: 0 1.2px 9.6px rgba(0, 0, 0, 0.35);
      --pw-shadow-dropdown: 0 0 18.6px rgba(0, 0, 0, 0.16);
      --pw-gradient-overlay: linear-gradient(218.53deg, rgba(255, 224, 249, 0.2) 30.09%, rgba(93, 157, 220, 0.2) 70.04%);
      --pw-border-gradient: linear-gradient(180deg, #40A9FF 0%, #E8AAFF 100%);
      --pw-divider: #E2E2E2;
      --pw-text: #050505;
      --pw-row-hover: #F5F5F5;
      --pw-font: "Recta", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

      --pw-fill-icon: linear-gradient(var(--pw-icon-bg), var(--pw-icon-bg));
      --pw-fill-button: linear-gradient(var(--pw-button-bg), var(--pw-button-bg));
      --pw-fill-panel: linear-gradient(var(--pw-panel-bg), var(--pw-panel-bg));
      --pw-fill-row-hover: linear-gradient(var(--pw-row-hover), var(--pw-row-hover));
    }

    *, *::before, *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    .pw-root {
      position: fixed; bottom: 0px; right: 25px;
      width: 68px; height: 500px;
      z-index: 2147483647; overflow: visible;
      pointer-events: none;
      font-family: var(--pw-font);
      line-height: 1.4;
      color: var(--pw-text);
    }
    .pw-root.pw-perio-chart-minimized {
      visibility: hidden;
      pointer-events: none;
    }

    @keyframes pw-spin { to { transform: rotate(360deg); } }
`;
